import React from 'react';
import { connect } from "react-redux";
import '../styles/clipboard.scss';
import TranslationService from "../app/services/TranslationService";
import { preloaderShow, preloaderHide, alert } from "../actions";
import {Textarea} from "./icymat-design/Textarea";
import axios from "axios";
import {config} from "../app/config";
import {Button} from "./icymat-design/Button";


export class ClipboardClass extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            content: null,
            textarea: ''
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.open !== this.props.open && this.props.open) {
            this.props.preloaderShow();

            const that = this;
            axios.get(config.apiAddress + '/clipboard')
                .then(function (response) {
                    that.setState({content: response.data.content});
                    that.props.preloaderHide();
                }).catch(function(error) {
                    that.props.preloaderHide();
                });
        }
    }

    getClassName = () => {
        return this.props.open ? ' imd-opened' : '';
    }

    save = (content) => {
        this.props.preloaderShow();

        const that = this;
        axios.post(config.apiAddress + '/clipboard', {content: content})
            .then(function (response) {
                that.setState({content: content});
                that.props.alert(TranslationService.trans(that.props.language, 'clipboard.saved'));
                that.props.close();
                that.props.preloaderHide();
            }).catch(function(error) {
                that.props.preloaderHide();
            });
    }

    handlePaste = (event) => {
        event.preventDefault();

        const clipboardData = event.clipboardData || window.clipboardData;
        const items = clipboardData.items;

        if (items) {
            for (let i = 0; i < items.length; i++) {
                if (items[i].type.indexOf('image') !== -1) {
                    const blob = items[i].getAsFile();
                    const reader = new FileReader();

                    reader.onload = (e) => {
                        const base64Image = e.target.result;

                        this.save(base64Image);
                    };

                    reader.readAsDataURL(blob);

                    return;
                }
            }
        }

        const pastedText = clipboardData.getData('text');
        if (pastedText) {
            this.save(pastedText);
        }

        this.props.close();
    };

    renderClipboard = () => {
        if (this.state.content === undefined || this.state.content === null) {
            return (<span className={'empty'}>{TranslationService.trans(this.props.language, 'clipboard.empty')}</span>);
        }

        if (this.state.content.startsWith('data:image')) {
            return (<img src={this.state.content} alt={TranslationService.trans(this.props.language, 'clipboard.title')} />);
        }

        if (this.state.content.startsWith('http')) {
            return (<a href={this.state.content} target="_blank" rel="noreferrer">{this.state.content}</a>);
        }

        const TextWithBreaks = ({ text }) => {
            const textWithBreaks = text.split('\n').map((line, index) => (
                <span key={index}>
                    {line}
                    <br />
                </span>
            ));

            return <div>{textWithBreaks}</div>;
        };

        return (<pre>{<TextWithBreaks text={this.state.content} />}</pre>);
    }

    saveFromTextarea = () => {
        if (this.state.textarea === '') {
            return;
        }

        this.save(this.state.textarea);
        this.setState({content: this.state.textarea, textarea: ''});
    }

    render() {
        return (
            <dialog id="clipboard" className={'imd-dialog imd-bg-blur-black' + this.getClassName()}>
                <div className="imd-dialog-body imd-bg-20-default imd-text-accent">
                    <header>
                        {TranslationService.trans(this.props.language, 'clipboard.title')}
                        <span className="imd-icon imd-icon-xmark imd-dialog-close" onClick={() => this.props.close()} />
                    </header>

                    <div className="imd-dialog-content">
                        <div className={'content imd-bg-transparent-gray imd-text-silver'}>
                            {this.renderClipboard()}
                        </div>

                        <hr />

                        <Textarea
                            value={this.state.textarea || ''}
                            placeholder={TranslationService.trans(this.props.language, 'clipboard.paste_here')}
                            onPaste={this.handlePaste}
                            onChange={(e) => this.setState({textarea: e.target.value})}
                        />
                    </div>

                    <footer>
                        <Button
                            text={TranslationService.trans(this.props.language, 'common.save')}
                            color={'main'}
                            onClick={() => this.saveFromTextarea()}
                        />
                    </footer>
                </div>
            </dialog>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        preloader: state.preloader
    }
};

export const Clipboard = connect(mapStateToProps, { preloaderShow, preloaderHide, alert })(ClipboardClass);
